export default function unicodeStringCompare(a, b) {
    if (!a) a = '';
    if (!b) b = '';
    var aCode = a.toLowerCase().replace('ё', 'е' + String.fromCharCode(1110));
    var bCode = b.toLowerCase().replace('ё', 'е' + String.fromCharCode(1110));
    if (aCode > bCode) return 1;
    if (aCode < bCode) return -1;
    else return 0;
}



// WEBPACK FOOTER //
// ./src/utils/unicodeStringCompare.js